module.exports = __webpack_public_path__ + "static/media/ownership.b9adefed.svg";